module.exports = __webpack_public_path__ + "img/Seite27.60ac294d.png";